import { Shape, ShapeOptions } from "../Shape";
import { SVGParsedPathData } from "../svg";
import { YZCanvasContext } from "../canvas";

export type HeartShapeOptions = {
  heartRx?: number;
  heartRy?: number;
} & ShapeOptions;

export class HeartShape extends Shape {
  rx: number;
  ry: number;

  constructor(options?: HeartShapeOptions) {
    super(options);
    this.rx = options?.heartRx || 10;
    this.ry = options?.heartRy || 10;
  }

  protected cloneShape(): HeartShape {
    const shape = new HeartShape({
      ...super.getBaseOptions(),
      heartRx: this.rx,
      heartRy: this.ry
    });
    return shape;
  }

  public toSVGPathData(): SVGParsedPathData[] {
    return [
      ["m", 0, 0],
      // bottom right curve
      ["l", this.rx * 2.4, -this.ry * 3.14],
      // top right curve
      ["a", this.rx / 2, this.ry / 2, 0, 0, 0, -this.rx * 2.4, -this.ry * 1.5],
      // top left curve
      ["a", this.rx / 2, this.ry / 2, 0, 0, 0, -this.rx * 2.4, this.ry * 1.5],
      // bottom left curve
      ["l", this.rx * 2.4, this.ry * 3.14],
      ["z"]
    ];
  }
}

export default HeartShape;
